'use client';

import { useFeatureFlagVariantKey } from 'posthog-js/react';

const DEFAULT_VARIANT = 'control' as const;
const TEST_VARIANT = 'test' as const;

export const usePostHogCardFindBestClinicFlag = () => {
  const variantKey = useFeatureFlagVariantKey('card-find-best-clinic') ?? DEFAULT_VARIANT;

  return {
    variant: variantKey,
    shouldShow: variantKey === TEST_VARIANT,
  };
};
